export default {
  title: 'CARDÁPIO TIGOO'
}
